"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@erm-tasku/styles");
const components_1 = require("@erm-tasku/components");
const react_i18next_1 = require("react-i18next");
const members_1 = require("use-open-seadragon/lib/types/members");
const GlobalStyles_1 = require("../styles/GlobalStyles");
const DeepZoom_1 = require("./DeepZoom");
const use_open_seadragon_1 = require("use-open-seadragon");
const AppContext_1 = require("../contexts/AppContext");
const Marker_1 = require("./Marker");
const Highlight_1 = require("./Highlight");
const OverlayImage_1 = require("./OverlayImage");
const Infoblock_1 = require("./Infoblock");
require("@erm-tasku/components/lib/bundle.css");
const App = () => {
    const { markers, selectedMarker, setSelectedMarker, visitedMarkers } = AppContext_1.useAppContext();
    const { t } = react_i18next_1.useTranslation();
    function handleClick(m) {
        setSelectedMarker(m);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(GlobalStyles_1.GlobalStyles, null),
        react_1.default.createElement(styles_1.BackgroundImage, null),
        react_1.default.createElement(components_1.GlobalButtonContainer, null,
            react_1.default.createElement(components_1.FullscreenToggle, { exitLabel: t(`ui.fullscreenExit`), enterLabel: t(`ui.fullscreen`) })),
        react_1.default.createElement(use_open_seadragon_1.ViewerProvider, null,
            react_1.default.createElement(DeepZoom_1.Viewer, { path: 'assets/memm.dzi' },
                markers &&
                    !selectedMarker &&
                    markers.map((m, i) => (react_1.default.createElement(use_open_seadragon_1.Overlay, { x: m.relX, y: m.relY, placement: members_1.Placement.CENTER, key: i },
                        react_1.default.createElement(Marker_1.Marker, { marker: m, onClick: () => handleClick(m), visited: visitedMarkers.includes(m) })))),
                selectedMarker && (react_1.default.createElement(use_open_seadragon_1.Overlay, { x: 0, y: 0, width: 1, height: 1 },
                    react_1.default.createElement(Highlight_1.Highlight, { data: `assets/highlight/${selectedMarker.highlightId}.svg`, type: "image/svg+xml" }))),
                selectedMarker && selectedMarker.overlay && (react_1.default.createElement(OverlayImage_1.OverlayImage, { width: selectedMarker.width, height: selectedMarker.height, src: `assets/overlays/${selectedMarker.overlay}`, "aria-hidden": true })))),
        react_1.default.createElement(Infoblock_1.Infoblock, { onClose: () => setSelectedMarker(null), visible: !!selectedMarker },
            react_1.default.createElement("h1", null, t(`K${selectedMarker === null || selectedMarker === void 0 ? void 0 : selectedMarker.highlightId}.pealkiri`)),
            react_1.default.createElement("p", { dangerouslySetInnerHTML: {
                    __html: t(`K${selectedMarker === null || selectedMarker === void 0 ? void 0 : selectedMarker.highlightId}.tekst`),
                } }),
            (selectedMarker === null || selectedMarker === void 0 ? void 0 : selectedMarker.media) &&
                (Array.isArray(selectedMarker === null || selectedMarker === void 0 ? void 0 : selectedMarker.media) ? (selectedMarker === null || selectedMarker === void 0 ? void 0 : selectedMarker.media.map((path) => react_1.default.createElement(components_1.InfoblockImage, { key: path, src: `assets/media/${path}` }))) : (selectedMarker === null || selectedMarker === void 0 ? void 0 : selectedMarker.media).endsWith('.mp4') ? (react_1.default.createElement(components_1.InfoblockVideo, { src: `assets/media/${selectedMarker.media}` })) : (react_1.default.createElement(components_1.InfoblockImage, { src: `assets/media/${selectedMarker.media}` }))))));
};
exports.App = App;
function renderInfoblockMedia(marker) {
    if (!marker || !marker.media) {
        return false;
    }
    if (Array.isArray(marker.media)) {
        return marker.media.map((path) => react_1.default.createElement(components_1.InfoblockImage, { key: path, src: `assets/media/${path}` }));
    }
    if (marker.media.endsWith('.mp4')) {
        return react_1.default.createElement(components_1.InfoblockVideo, { src: `assets/media/${marker.media}` });
    }
    else {
        return react_1.default.createElement(components_1.InfoblockImage, { src: `assets/media/${marker.media}` });
    }
}
